import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useFilter } from '../../hooks'
import { sendStaffAppMetaData } from '../../eventTriggers'
import useMedicationsLoader from '../../../Medications/useMedicationsLoader'

export const Medications = () => {
  useMedicationsLoader()
  const [ filter, setFilter, Input ] = useFilter()
  const { medications } = useSelector(state=>state)
  const tabDefaultMetaData = useSelector(state=>state.config.tab_default_meta_data.find(tab=> tab.detail == 'meds'))
  const dispatch = useDispatch()

  function handleClick(resource) {
    dispatch({
      type: "EDIT_RESOURCE",
      payload: {
        resourceName: "medication",
        resource
      }
    })
    sendStaffAppMetaData(tabDefaultMetaData.modal)
  }

  return(
    <div>
      <Input {...{filter, setFilter }}/>
      {
        medications.filter(medication=>((medication.name || '').toLowerCase().includes(filter.toLowerCase()))).map(medication=>(
          <div key={medication.id} onClick={()=>handleClick(medication)} className="p-4 border-bottom clickable">
            <b>{ medication.name }</b>
          </div>
        ))
      }
    </div>
  )
}